import { showNativeCallToast } from './show-toast';

export function callToNativeListener(payload): void {
  showNativeCallToast(payload);
}

export function callFromNativeListener(payload): void {
  showNativeCallToast(payload);
}
